"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementInstanceResultStatusSchema = exports.RequirementInstanceResultStatus = void 0;
exports.convertStatusToEnum = convertStatusToEnum;
exports.convertBoundaryLevelToRequirementStatus = convertBoundaryLevelToRequirementStatus;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("../../BoundaryLevel");
var RequirementInstanceResultStatus;
(function (RequirementInstanceResultStatus) {
    RequirementInstanceResultStatus["Error"] = "error";
    RequirementInstanceResultStatus["Warning"] = "warning";
    RequirementInstanceResultStatus["Success"] = "success";
    RequirementInstanceResultStatus["HumanNeeded"] = "humanNeeded";
    RequirementInstanceResultStatus["Exception"] = "exception";
})(RequirementInstanceResultStatus || (exports.RequirementInstanceResultStatus = RequirementInstanceResultStatus = {}));
exports.RequirementInstanceResultStatusSchema = zod_1.z.nativeEnum(RequirementInstanceResultStatus);
function convertStatusToEnum(status) {
    switch (status) {
        case 'error':
            return RequirementInstanceResultStatus.Error;
        case 'warning':
            return RequirementInstanceResultStatus.Warning;
        case 'success':
            return RequirementInstanceResultStatus.Success;
        case 'humanNeeded':
            return RequirementInstanceResultStatus.HumanNeeded;
        case 'exception':
            return RequirementInstanceResultStatus.Exception;
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}
function convertBoundaryLevelToRequirementStatus(level) {
    switch (level) {
        case BoundaryLevel_1.BoundaryLevel.Error:
            return RequirementInstanceResultStatus.Error;
        case BoundaryLevel_1.BoundaryLevel.Warning:
            return RequirementInstanceResultStatus.Warning;
        case BoundaryLevel_1.BoundaryLevel.Recommendation:
            return RequirementInstanceResultStatus.Success;
        default:
            return RequirementInstanceResultStatus.Exception;
    }
}
//# sourceMappingURL=RequirementInstanceResultStatus.js.map